const APP_CONSTANT = {
    themeOverride: {
        deprecatedFont: false
    },
    includeBaseCss: false,
    footerInfo: {
        CopyrightText: `© 2026 UnitedHealthcare, All Rights Reserved`,
        Contact: `Contact & Support`,
        Privacy: `Privacy`,
        TermsOfUse: `Terms of Use`,
        contactURL: `/myhome/contactus`,
        privacyURL: `/myhome/privacy-policy`,
        termsOfUseURL: `/myhome/terms-of-use`,
    },
};
export default APP_CONSTANT;